import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Popup from 'reactjs-popup'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate } from 'react-router-dom'
import showToast from '@util/ToastUtil'

import Card from '@components/card'
import ModalOptions from '@components/modal/modalOptions'
import LoanDevolutionModal from '@components/modal/loanDevolutionModal'

import {
  refundLoan as refundLoanAction,
} from '@stores/actions/loan'

import colors from '@settings/styleSettings'
import { getDateFromFormattedDate, getDateStringFromFormattedDateStr, getDateStringFromUsableDateStr } from '@util/timeUtil'

import {
  Row, Divisor, RowTitle, TextName, DescriptionText, Title, Icon, Option, DelayCard
} from './style'
import moment from 'moment'

const LoanList = ({
  loans, isOpenLoan, refundLoan, refreshLoans
}) => {

  const [showDevolutionModal, setShowDevolutionModal] = useState(false)
  const [selectedLoan, setSelectedLoan] = useState(null)
  const navigate = useNavigate()
  const currentDate = new Date()

  const isToday = (date) => {
    return date.getDay() === currentDate.getDay()
    && date.getMonth() === currentDate.getMonth()
    && date.getFullYear() === currentDate.getFullYear()
  }

  const checkDelay = (date) => {
    const loanDate = getDateFromFormattedDate(date)
    return moment(currentDate).isAfter(loanDate) && !isToday(loanDate)
  }

  const getColor = (date) => {
    if (!isOpenLoan) return [colors.strongGray, colors.softGray]
    if (checkDelay(date) && date) return [colors.strongYellow, colors.softYellow]

    return [colors.strongGreen, colors.softGreen]
  }

  const handleDevolution = (loan) => {
    setSelectedLoan(loan)
    setShowDevolutionModal(true)
  }

  const onShowLoanTerm = (loan) => {
    navigate(`termo-de-emprestimo/${loan.id}`)
  }

  const onRefundLoan = (loan) => {
    refundLoan({
      id: loan.id,
      beneficiaryId: loan.beneficiaryId,
      assign: loan.assign,
      loanDate: getDateFromFormattedDate(loan.loanDate),
      status: 1,
      equipment: loan.equipment,
      loanUser: { id: loan.loanUser.id },
      loanLimitDate: getDateStringFromFormattedDateStr(loan.loanLimitDate),
    }, (data) => {
      if (data) {
        refreshLoans()
        setShowDevolutionModal(false)
        showToast('success', 'Devolução realizada com sucesso')
      }
    })
  }

  const row = (loan) => {
    return (
      <Row key={loan.id}>
        <RowTitle>
          <Icon color={getColor(loan.loanLimitDate)}>
            <span className="material-symbols-outlined">
              business_center
            </span>
          </Icon>
          <Title>{loan.equipment.name}</Title>
        </RowTitle>
        <Divisor />
        <TextName>
          {loan.beneficiaryName}
        </TextName>
        <Divisor />
        <DescriptionText isDelay={loan.loanLimitDate && checkDelay(loan.loanLimitDate)}>
          {!isOpenLoan ? `Devolução registrada por ${loan.refundUser.name} em ${getDateStringFromUsableDateStr(loan.refundDate)}` : `Realizado em ${getDateStringFromUsableDateStr(loan.loanDate)}`}
        </DescriptionText>
        {loan.loanLimitDate && checkDelay(loan.loanLimitDate) && isOpenLoan && (
          <>
            <Divisor />
            <DelayCard>
              Atrasado
            </DelayCard>
          </>
        )}

        <Popup
          trigger={() => (
            <Option>
              <span className="material-symbols-outlined">
                more_vert
              </span>
            </Option>
          )}
          on={['hover', 'focus']}
          position="right center"
          closeOnDocumentClick
        >
          <ModalOptions
            isOpenLoan={isOpenLoan}
            setShowDevolutionModal={() => handleDevolution(loan)}
            onShowTerm={() => onShowLoanTerm(loan)}
          />
        </Popup>
      </Row>
    )
  }

  return (
    <>
      <Card
        style={{
          borderRadius: 0,
          boxShadow: 'none',
          marginTop: '5px',
          marginBottom: '0px',
          width: '100%',
          padding: '0px',
          gap: '0px',
        }}
      >
        {loans && loans.map((loan) => row(loan))}
      </Card>
      {showDevolutionModal && (

        <LoanDevolutionModal
          onDevolution={() => onRefundLoan(selectedLoan)}
          setClose={() => setShowDevolutionModal(false)}
          open={showDevolutionModal}
        />

      )}
    </>
  )
}

LoanList.propTypes = {
  loans: PropTypes.arrayOf(PropTypes.object),
  refundLoan: PropTypes.func.isRequired,
  isOpenLoan: PropTypes.bool,
  refreshLoans: PropTypes.func.isRequired,
}

LoanList.defaultProps = {
  loans: null,
  isOpenLoan: false,
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  refundLoan: refundLoanAction
}, dispatch)

export default connect(null, mapDispatchToProps)(LoanList)
